import { call, put, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    sendAdminNotification,
    adminNotificationSent,
    adminNotificationFailed,
} from '../notifications';
import { showToastAction } from '../ui';

function* sendAdminNotificationEffect({ payload }) {
    try {
        const formData = payload.data || payload;

        const response = yield call(SendApiRequest, {
            url: apiRoutes.sendAdminNotification,
            method: 'POST',
            body: {
                recipientType: formData.recipientType,
                sendToAll: formData.sendToAll,
                userIds: formData.userIds || [],
                message: formData.message,
            },
        });

        yield put(adminNotificationSent(response));

        yield put(
            showToastAction({
                type: 'success',
                message: response?.message || 'Notification sent successfully!',
            }),
        );

        if (payload.resolve && typeof payload.resolve === 'function') {
            payload.resolve(response);
        }
    } catch (error) {
        console.error('Error sending admin notification:', error);

        const errorMessage =
            error?.response?.data?.error ||
            error?.message ||
            'Failed to send notification';

        yield put(adminNotificationFailed({ error: errorMessage }));

        yield put(
            showToastAction({
                type: 'error',
                message: errorMessage,
            }),
        );

        if (payload.reject && typeof payload.reject === 'function') {
            payload.reject(error);
        }
    }
}

export const notificationsSagas = [
    takeLatest(sendAdminNotification.type, sendAdminNotificationEffect),
];
